import { Box, Icon, SxProps } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import React from "react";

import Link from "../Link";

type ShowMoreProps = {
  sx?: SxProps;
  [key: string]: any;
};

export default function ShowMore({
  url,
  icon = null,
  text,
  sx = {},
  trackingName
}: ShowMoreProps) {
  const { t } = useTranslation("client\\components\\parentDashboard\\ShowMore");
  return (
    <Link to={url} trackingName={trackingName || `parent dashboard ${text}`}>
      <Box
        flex
        sx={[
          {
            textAlign: "center",
            color: "grey.900",
            border: "1px solid",
            borderColor: "grey.300",
            borderRadius: "11px",
            fontWeight: "fontWeightMedium",
            padding: "0.5em",
            marginTop: "8px",
            marginBottom: "48px",
            alignItems: "center",
            justifyContent: "center"
          },
          ...(Array.isArray(sx) ? sx : [sx])
        ]}
      >
        {icon && (
          <Icon
            sx={{
              paddingRight: "8px",
              fontSize: "22px"
            }}
            icon={icon}
          />
        )}
        <Box
          sx={{
            whiteSpace: "nowrap",
            overflowX: "hidden",
            textOverflow: "ellipsis"
          }}
        >
          {text || t("Show More")}
        </Box>
      </Box>
    </Link>
  );
}
